module.exports = __webpack_public_path__ + "static/media/cloud_icon.0a2e49aa.svg";